// Ported from vlookup-dramatic/lib/accents.ts by scripts/revamp/port-design.js
/*
 * The brand has exactly two accent hues — the red and the blue of the logo.
 * Card rows that want per-card colour alternate between these two rather than
 * reaching for a third; a green or a purple in the run reads as arbitrary.
 * brand-navy is deliberately absent: it is a text colour here, never a fill
 * (see the palette notes in globals.css).
 *
 * `tint` is a wash light enough to carry brand-navy body copy at full
 * contrast; `bar` and `text` are the solid hue for rules, labels, and icons.
 */
export const brandAccents = [
    {
        tint: "bg-brand-red/8",
        bar: "bg-brand-red",
        text: "text-brand-red",
    },
    {
        tint: "bg-brand-blue/8",
        bar: "bg-brand-blue",
        text: "text-brand-blue",
    },
];
